import type { SectionAiSelection } from "../types/gameRuleKbGenerate";

/** Sections with a non-empty AI selection, in persisted selection order. */
export const deriveAiSelectionOrder = (
  sectionOrder: readonly string[],
  aiSelections: Record<string, SectionAiSelection>,
  selectedSectionIds: readonly string[],
): string[] => {
  const hasSelection = (sectionId: string): boolean =>
    Boolean(aiSelections[sectionId]?.finalContent?.trim());

  const selectedIds = new Set(
    selectedSectionIds.filter((sectionId) => hasSelection(sectionId)),
  );
  if (selectedIds.size === 0) {
    return [];
  }

  const fromPersistedOrder = sectionOrder.filter((sectionId) =>
    selectedIds.has(sectionId),
  );
  if (fromPersistedOrder.length > 0) {
    return fromPersistedOrder;
  }

  return selectedSectionIds.filter((sectionId) => selectedIds.has(sectionId));
};

/** Append section on first AI selection; keep order when re-selecting options. */
export const appendAiSelectionOrder = (
  currentOrder: readonly string[],
  sectionId: string,
): string[] => {
  if (currentOrder.includes(sectionId)) {
    return [...currentOrder];
  }
  return [...currentOrder, sectionId];
};
